var next = __webpack_require__.x;
__webpack_require__.x = () => {
	return Promise.all([
		__webpack_require__.e(8078),
		__webpack_require__.e(1274)
	]).then(next);
};